import * as React from 'react';
import {SignUpProvider} from './useSignUp';

export const withSignUp = (Component) => (props) => (
  <SignUpProvider>
    <Component {...props} />
  </SignUpProvider>
);
